import React from "react";
import Dropdown from "react-bootstrap/Dropdown";
import { format } from "date-fns";
import { Link } from "react-router-dom";

import "../NotificationListItem/NotificationListItem.css";

const NotificationListItem = ({
  redirectTo,
  senderImage,
  title,
  desc,
  status,
  date,
  onClick,
}) => {
  const dateObject = new Date(date);
  const time = format(dateObject, "h:mm");
  const meridiem = format(dateObject, "aaa").toLowerCase();
  const formattedTime = `${time}${meridiem}`;
  const formattedDate = format(dateObject, "d MMM yyyy");
  return (
    <Dropdown.Item
      className={status !== "seen" ? "unseen-noti" : ""}>
      <Link to={
        redirectTo === "Reservation" ? "/reserve" :
          redirectTo === "Reward" ? "/reward/customer" :
            `/${redirectTo.toLowerCase()}`
      }>

        <div className="" onClick={onClick}>
          <div className="noti-image-wrapper text-center">
            <img src={senderImage} alt="noti" className="imgNotiProfile" />
          </div>
          <div className="noti-text-wrapper">
            <span>{desc}</span>
          </div>
          <div className="noti-datetime-wrapper">
            <div className="noti-date">{formattedDate}</div>
            <div className="noti-time">{formattedTime}</div>
          </div>
        </div>
      </Link>
    </Dropdown.Item>
  );
};

export default NotificationListItem;
